import React from "react";
import { IMAGES } from "../site-data";

export default function AboutAuthor() {
  return (
    <section
      id="about"
      data-testid="about-author-section"
      className="relative py-24 lg:py-36 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative">
            <img
              src={IMAGES.author1}
              alt="Nitin Sawhney — author"
              data-testid="about-author-image"
              className="relative w-full max-w-sm mx-auto lg:max-w-none grayscale hover:grayscale-0 transition-all duration-700 border border-[#e5dcd0] hover:scale-105 hover:-translate-y-2 hover:shadow-2xl"
              style={{ aspectRatio: "4/5", objectFit: "cover", objectPosition: "center" }}
            />
            <div className="absolute -bottom-6 -right-6 hidden sm:block border border-[#8b2e3e] px-6 py-4 bg-[#f9f6f0]">
              <p className="eyebrow">Author</p>
              <p className="font-serif text-xl text-[#1c1a1a] mt-1">Nitin Sawhney</p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <p className="eyebrow mb-5">About the Author</p>
          <h2
            className="font-serif text-4xl lg:text-5xl leading-tight tracking-tight text-[#1c1a1a]"
            data-testid="about-author-title"
          >
            Bedtime tales, shaped into a <span className="italic text-[#8b2e3e]">first book</span>.
          </h2>

          <div className="mt-8 space-y-5 text-[#4a4646] leading-relaxed text-lg max-w-xl">
            <p>
              Nitin Sawhney discovered the magic of storytelling through the simplest
              and most intimate of moments — bedtime tales shared with his daughter,
              nephews, and nieces.
            </p>
            <p>
              A seasoned IT professional with over two decades of experience, he has
              long believed that the most enduring stories are those that come from the
              heart and carry gentle lessons of love, honesty, and friendship.
            </p>
            <p>
              Inspired by his daughter's delight in his lovingly "cooked-up" bedtime
              stories, Nitin began gathering his favourites, eventually shaping them into
              his debut collection. When he is not crafting stories or solving complex
              problems, he finds joy in singing and composing music — pursuits that
              reflect the same rhythm and emotion found in his writing.
            </p>
          </div>

          <div className="mt-10 flex flex-wrap gap-x-10 gap-y-4 border-t border-[#e5dcd0] pt-6 max-w-xl">
            <div>
              <p className="eyebrow !text-[#4a4646]">Based in</p>
              <p className="font-serif text-xl text-[#1c1a1a]">India</p>
            </div>
            <div>
              <p className="eyebrow !text-[#4a4646]">Writes</p>
              <p className="font-serif text-xl text-[#1c1a1a]">Fiction</p>
            </div>
            <div>
              <p className="eyebrow !text-[#4a4646]">Also loves</p>
              <p className="font-serif text-xl text-[#1c1a1a]">Music & Traveling</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
